<template>
  <div class="time-list">
    <div class="navbtns">
      <button @click="showMoreBefore" class="md-icon left">expand_less</button>
      <h4>{{ itemID }}:</h4>
      <button @click="howManyBefore = 0" class="md-icon right">clear</button>
    </div>
    <ItemList v-for="id in sectionKeys" :itemID="id" :key="id"></ItemList>
    <div class="navbtns">
      <button @click="showMore" class="md-icon left">expand_more</button>
      <button @click="howManyAfter = 0" class="md-icon right">clear</button>
    </div>
  </div>
</template>

<style scoped>
.time-list {
  margin: var(--basic-margin);
  padding: var(--basic-padding);
  background-color: var(--bg-color-list);
  border-radius: var(--rounding-larger);
  width: fit-content;
}
.time-list h4  {
  margin: 0;
}

.time-list .item-list {
  margin: var(--basic-padding) 0 calc(2 * var(--basic-padding)) 0;
  padding: 0;
}

.time-list::v-deep .list-header {
  background-color: var(--bg-color-date-header);
}

.navbtns {
  display: flex;
  gap: 8px;
}

button {
  cursor: pointer;
  height: var(--min-button-height);
  flex: auto;
  background: transparent;
  border: none;
  display: flex;
  margin: 0;
  border-radius: var(--rounding-smaller);
  padding: 0;
}

.navbtns button:hover {
  background: var(--bg-color-hover);
}

.left {
  justify-content: left;
}

.right {
  justify-content: right;
  font-size: 20px !important;
}
</style>

<script>
import moment from "moment";
import ItemList from "./ItemList.vue";
import { toMomentJSUnit } from "@/time-utils";

const now = moment().startOf("day");
const isoDateFormat = "Y-MM-DD";

export default {
  props: ["itemID"],
  components: {
    ItemList,
},
  data() {
    return {
      howManyBefore: 0,
      howManyAfter: 0,
    };
  },
  computed: {
    sectionKeys() {
      const result = [];
      const unit = this.itemID.slice(0, -1) // remove plural
      for (let i = -this.howManyBefore; i <= this.howManyAfter; i++) {
        const isoDate = now
          .clone()
          .startOf(toMomentJSUnit(unit))
          .add(i, unit)
          .format(isoDateFormat);
        const key = unit + ":" + isoDate;
        result.push(key);
      }
      return result;
    },
  },
  methods: {
    showMore() {
      this.howManyAfter += this.howManyAfter + 2;
    },
    showMoreBefore() {
      this.howManyBefore += this.howManyBefore + 1;
    },
  },
};
</script>
